import { images } from "../constants";

const personData = {
    name: "mgr inż. Mariusz Gądziak",
    roleKey: "person.gadziak.role",
    image: images.poznajnas,
    descriptionKeys: [
        "person.gadziak.paragraphs.0",
        "person.gadziak.paragraphs.1",
        "person.gadziak.paragraphs.2",
        "person.gadziak.paragraphs.3",
        "person.gadziak.paragraphs.4",
        "person.gadziak.paragraphs.5"
    ]
};

export default personData;